
import React, { useState, useEffect } from "react";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MenuIcon from '@mui/icons-material/Menu';
import "./TravelItineraryTopButtons.css"

function TravelItineraryTopButtons() {
  
  return (
    <>
      <div className="d-flex app">
        <div
          className="container-fluid p-0"
          style={{ padding: "2rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem"}}>
                Travel Itinerary | <HomeOutlinedIcon style={{color:"#5B489D",width:"34px",height:"27px"}}/>{" "}
                  <span style={{ fontSize: "20px",color:"#6A6A6A" }}>&gt; Order List</span> {" "}
                  <span style={{ fontSize: "20px",color:"#6A6A6A" }}>&gt; Order Summary</span>
                  <span style={{ fontSize: "20px",color:"#6A6A6A" }}>&gt; Travel Itinerary</span>
                </h1>
              </div>
            </div>
    
        </div>
          </div>
        </div>
    </>
  );
}

export default TravelItineraryTopButtons;
